// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"e329f939","767":"4ec0a6fe","945":"4783dffb"}[chunkId] + ".chunk.js";
};